import { observer } from 'mobx-react-lite'
import { type ScopeChangeRequestItemViewModel } from '@/features/admin/scope-change-requests/ScopeChangeRequestItemViewModel'
import { type ColumnId } from '@/features/admin/scope-change-requests/scope-change-request-table-columns'
import { ScopeChangeRequestRow } from '@/features/admin/scope-change-requests/components/ScopeChangeRequestRow'
import {
  formatPhase,
  formatTableStatus,
  formatTimeOpen,
} from '@/features/admin/scope-change-requests/scope-change-request-formatters'

export interface ScopeChangeRequestRowContainerProps {
  vm: ScopeChangeRequestItemViewModel
  columnIds: ColumnId[]
}

export const ScopeChangeRequestRowContainer = observer(
  function ScopeChangeRequestRowContainer({
    vm,
    columnIds,
  }: ScopeChangeRequestRowContainerProps) {
    const scopeChangeRequest = vm.scopeChangeRequest
    return (
      <ScopeChangeRequestRow
        columnIds={columnIds}
        jobId={scopeChangeRequest.job.id}
        phase={formatPhase(scopeChangeRequest.status)}
        displayStatus={formatTableStatus(scopeChangeRequest.status)}
        isActive={vm.isActive}
        onPress={vm.select}
        createTime={scopeChangeRequest.createTime}
        jobShortId={scopeChangeRequest.job.shortId}
        workspaceName={scopeChangeRequest.workspace.name}
        jobDisplayName={scopeChangeRequest.job.displayName}
        open={formatTimeOpen(scopeChangeRequest.createTime)}
      />
    )
  },
)
